import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_9.module.css";
import Head from "next/head";
import { Link } from "@mui/material";
import { useRouter } from 'next/router';
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter9.json";

function Chapter_9() {
  // const corosalref = useRef()

  // useEffect(() => {
  //   if (corosalref.current) {
  //     corosalref.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start"
  //     })
  //   }
  //   console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;

  return (
    <>
      <Head>
        <title>Gateway between the worlds | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-IX"
        ></meta>
        <meta
          property="og:title"
          content="Gateway between the worlds | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter9_OG_image_Mithun_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Illustration depicting a radiant gateway floating amidst a cosmic background, symbolizing the passage between the physical and spiritual realms. The gateway is surrounded by swirling ethereal energy, with symbols representing infinity, balance, and divine connection. Light emanates from the gateway, suggesting enlightenment and the union of the material and spiritual worlds."></meta>
        <meta
          property="og:description"
          content="Symbols exist as doorways between dimensions of being. Partly known to our logical framework of the physical world and partially rooted in an unknowable infinite realm."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=8"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter9_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Illustration depicting a radiant gateway floating amidst a cosmic background, symbolizing the passage between the physical and spiritual realms. The gateway is surrounded by swirling ethereal energy, with symbols representing infinity, balance, and divine connection. Light emanates from the gateway, suggesting enlightenment and the union of the material and spiritual worlds."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=8"></meta>
        <meta name="twitter:title" content="Gateway between the worlds | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Symbols exist as doorways between dimensions of being. Partly known to our logical framework of the physical world and partially rooted in an unknowable infinite realm."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=9" />
      </Head>


      <Common_html BlockData={BlockData} />
    </>
  );
}

export default Chapter_9;
